<template>
    <v-main>
        <a class="skip-to-content-link" href="#mainmenu"
            >Przejdź do menu głównego</a
        >
        <a class="skip-to-content-link" href="#cards"
            >Przejdź do sekcji kategorie</a
        >
        <a class="skip-to-content-link" href="#news"
            >Przejdź do sekcji aktualności
        </a>

        <!--mobile app bar-->
        <v-layout
            min-height="90"
            app
            v-if="
                this.$vuetify.breakpoint.name == 'xs' ||
                    this.$vuetify.breakpoint.name == 'sm'
            "
            color="white"
            class="pt-3"
        >
            <v-row class="justify-center">
                <v-card-actions class="pa-0">
                    <router-link to="/">
                        <img
                            class="mb-6 ml-2"
                            style="height: 60px"
                            src="/images/g92.png"
                            alt="Godło Rzeczypospolitej Polskiej"
                        />

                        <img
                            class="ml-3 mb-2 pa-2"
                            src="/images/ans_as_logo.svg"
                            style="height: 90px"
                            aria-label="logo Akademia Nauk Stosowanych Angelusa Silesiusa"
                        />
                        <img
                            class="mb-6"
                            src="/images/eu-center-pl.svg"
                            style="height: 60px"
                            alt="Znak Unii Europejskiej"
                        />
                    </router-link>
                </v-card-actions>
            </v-row>
        </v-layout>
        <!--mobile app bar-->
        <!--desktop app bar-->
        <v-layout
            @keyup.tab="handleTabPress()"
            style="height: 130px"
            row
            wrap
            v-if="
                this.$vuetify.breakpoint.name == 'lg' ||
                    this.$vuetify.breakpoint.name == 'xl' ||
                    this.$vuetify.breakpoint.name == 'md'
            "
        >
            <v-flex xs3 md1 block class="ma-5">
                <v-row class="justify-end justify-md-end">
                    <img
                        src="/images/g92.png"
                        style="height: 80px"
                        class="pt-3"
                        alt="Godło Rzeczypospolitej Polskiej"
                    />
                </v-row>
            </v-flex>

            <router-link to="/">
                <v-flex xs5 md1>
                    <img
                        src="/images/ans_as_logo.svg"
                        class="mt-3 pa-3 justify-start"
                        style="height: 110px"
                        aria-label="logo Akademia Nauk Stosowanych Angelusa Silesiusa"
                    />
                </v-flex>
            </router-link>
            <v-flex xs12 md3 class="mt-11 ml-n8 bg-red-line"> </v-flex>

            <v-flex xs10 md2 class="mt-9 ml-n3 hidden-sm-and-down">
                <v-img
                    transition="scale-transition"
                    lazy-src="/images/images/PUAS_ksztalcimy_praktycznie.svg"
                    height="60"
                    src="/images/PUAS_ksztalcimy_praktycznie.svg"
                    alt="Banner Kształcimy praktycznie"
                ></v-img>
            </v-flex>
            <v-flex xs12 md4 class="mt-2 ml-n3 bg-blue-line"> </v-flex>

            <v-layout class="mt-n8">
                <v-row row wrap class="mr-16 pr-16 mt-n9">
                    <v-flex xs12 md12>
                        <v-card-actions class="justify-end">
                            <v-btn
                                icon
                                @click="dialog = true"
                                aria-label="Wyszukaj na stronie"
                            >
                                <v-icon class="pl-1">mdi-magnify</v-icon>
                            </v-btn>
                            <v-btn
                                icon
                                href="https://www.facebook.com/ans.walbrzych/"
                                aria-label="Przejdź do Facebook"
                            >
                                <v-icon class="pl-1">mdi-facebook</v-icon>
                            </v-btn>

                            <v-btn
                                icon
                                href="https://www.instagram.com/ans.walbrzych"
                                aria-label="Przejdź do instagram"
                            >
                                <v-icon class="pl-1">mdi-instagram</v-icon>
                            </v-btn>

                            <v-btn
                                icon
                                class="ml-2"
                                href="https://bip.ans.edu.pl"
                                aria-label="Przejdź do Biuletyn Informacji Publicznej"
                            >
                                <v-avatar size="28px">
                                    <img
                                        src="/images/bip.svg"
                                        alt="Przejdź do Biuletyn Informacji Publicznej"
                                    />
                                </v-avatar>
                            </v-btn>
                        </v-card-actions>
                        <v-card-actions
                            style="right: 0px; position: absolute; top: 60px"
                            class="justify-end"
                        >
                            <img
                                class="mt-0"
                                src="/images/eu-center-pl.svg"
                                style="height: 60px"
                                alt="Znak Unii Europejskiej"
                            />
                        </v-card-actions>
                        <v-card-actions
                            style="
                                right: 0px;
                                position: absolute;
                                right: 65px;
                                top: 10px;
                            "
                            class="mr-12 pa-3 justify-end"
                        >
                            <v-btn
                                icon
                                :aria-label="'Odwrócenie kolorów'"
                                @click="toggleState('inverted')"
                            >
                                <v-icon class="pl-1">mdi-invert-colors</v-icon>
                            </v-btn>
                            <v-btn
                                icon
                                @click="toggleState('highlighted')"
                                :aria-label="'Podkreślanie linków'"
                            >
                                <v-icon class="pl-1"
                                    >mdi-link-variant-minus</v-icon
                                >
                            </v-btn>
                            <v-btn
                                icon
                                @click="toggleState('greyscaled')"
                                :aria-label="'tryb szarości'"
                            >
                                <v-icon class="pl-1">mdi-water-off</v-icon>
                            </v-btn>
                            <v-btn
                                icon
                                @click="toggleState('accessibileFontSize')"
                                :aria-label="'Zmiana rozmiaru tekstu'"
                            >
                                <v-icon class="pl-1">mdi-format-size</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-flex>
                </v-row>
            </v-layout>
        </v-layout>
        <!--desktop app bar-->

        <!--menu mobile -->
        <div
            class="pa-0 blue darken-5"
            v-if="
                this.$vuetify.breakpoint.name == 'xs' ||
                    this.$vuetify.breakpoint.name == 'sm'
            "
        >
            <v-row>
                <v-col cols="12" xs="12">
                    <v-card-actions>
                        <v-tabs show-arrows>
                            <v-tab
                                v-for="(item, index) in items"
                                :key="index"
                                @click="openUrl(item.url)"
                            >
                                {{ item.text }}</v-tab
                            >
                        </v-tabs>
                    </v-card-actions>
                    <v-card-actions>
                        <v-col cols="7" xs="7" dark>
                            <v-btn
                                id="#search"
                                color="white"
                                icon
                                x-large
                                light
                                @click="dialog = true"
                                aria-label="Wyszukaj na stronie"
                            >
                                <v-icon class="pl-1">mdi-magnify</v-icon>
                            </v-btn>
                            <a href="https://www.facebook.com/ans.walbrzych/">
                                <v-btn
                                    color="white"
                                    light
                                    x-large
                                    icon
                                    aria-label="przejdź do Facebook przycisk"
                                >
                                    <v-icon>mdi-facebook</v-icon>
                                </v-btn>
                            </a>
                            <a href="https://www.instagram.com/ans.walbrzych">
                                <v-btn
                                    color="white"
                                    x-large
                                    light
                                    icon
                                    aria-label="przejdź do instagram"
                                >
                                    <v-icon>mdi-instagram</v-icon>
                                </v-btn>
                            </a>
                            <a href="https://bip.ans.edu.pl">
                                <v-btn
                                    color="white"
                                    light
                                    fab
                                    x-small
                                    aria-label="przejdź do biuletyn informacji publicznej przycisk"
                                >
                                    <v-avatar size="24px">
                                        <img
                                            alt="Biuletyn Informacji Publicznej"
                                            src="/images/bip.svg"
                                        />
                                    </v-avatar>
                                </v-btn>
                            </a>
                        </v-col>
                        <v-col class="justify-end">
                            <v-btn
                                class="pr-4"
                                href="https://ans.edu.pl/kandydat/studia-dla-cudzoziemcow/studies-for-foreigners"
                                aria-label="rekrutacja, wersja językowa angielska"
                                outlined
                                >ENG
                            </v-btn>
                            <v-btn
                                href="https://ans.edu.pl/kandydat/studia-dla-cudzoziemcow/navcannya-dlya-inozemciv"
                                aria-label="rekrutacja, wersja językowa ukraińska"
                                outlined
                                >UKR
                            </v-btn>
                        </v-col>
                    </v-card-actions>
                </v-col>
                <!--end menu arrow-->
            </v-row>
        </div>
        <!--menu mobile -->

        <!-- menu desktop-->
        <nav
            class="blue darken-5"
            v-if="
                this.$vuetify.breakpoint.name == 'xl' ||
                    this.$vuetify.breakpoint.name == 'lg' ||
                    this.$vuetify.breakpoint.name == 'md'
            "
        >
            <v-row row>
                <v-col class="pt-0" cols="12" md="12">
                    <v-col class="text-right pa-2">
                        <span
                            v-for="item in items"
                            :key="item.text"
                            id="mainmenu"
                        >
                            <v-icon color="white">{{ item.icon }}</v-icon>
                            <a class="mt-1 pa-2" :href="item.url">
                                {{ item.text }}
                            </a>
                        </span>
                        <v-icon color="white">mdi-dots-vertical</v-icon>
                        <v-btn
                            href="https://ans.edu.pl/kandydat/studia-dla-cudzoziemcow/studies-for-foreigners"
                            aria-label="rekrutacja, wersja językowa angielska"
                            outlined
                            >ENG
                        </v-btn>
                        <v-btn
                            href="https://ans.edu.pl/kandydat/studia-dla-cudzoziemcow/navcannya-dlya-inozemciv"
                            aria-label="rekrutacja, wersja językowa ukraińska"
                            outlined
                            >UKR
                        </v-btn>
                    </v-col>
                </v-col>
            </v-row>
        </nav>
        <v-card dark> </v-card>
        <!--end desktop menu-->

        <!--dialog search-->
        <v-dialog
            transition="dialog-bottom-transition"
            max-width="650"
            width="340"
            v-model="dialog"
        >
            <v-card>
                <v-card-title class="white--text text-h5 blue darken-5">
                    Znajdź na stronie ...
                </v-card-title>
                <v-card-text class="pa-6">
                    <v-text-field
                        class="pt-2 ml-0"
                        @keyup.enter="search()"
                        label="Wpisz tutaj wyszukiwane słowo"
                        v-model="searchValue"
                    >
                    </v-text-field>
                    <v-alert>{{ this.validateText }}</v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        large
                        dark
                        color="blue darken-5"
                        @click="dialog = false"
                        >Zamknij</v-btn
                    >
                    <v-btn large dark color="red darken-5" @click="search">
                        <v-icon> mdi-magnify </v-icon>
                        Wyszukaj
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-main>
</template>
<script>
import { mapGetters } from "vuex";
import _ from "lodash";
export default {
    data() {
        return {
            accessibilityStates: {
                inverted: false,
                highlighted: false,
                accessibileFontSize: false,
                greyscaled: false
            },

            expand: false,
            drawer: false,
            dialog: false,
            tabmenu: true,
            items: [
                {
                    icon: "mdi-home",
                    text: "Strona główna",
                    url: "/"
                },

                {
                    icon: "mdi-circle-outline",
                    text: "Erasmus+",
                    url: "/erasmus"
                },
                {
                    icon: "mdi-circle-outline",
                    text: "Jakość kształcenia",
                    url: "/jakosc-ksztalcenia"
                },
                {
                    icon: "mdi-circle-outline",
                    text: "Zadania finansowane z budżetu państwa",
                    url: "/zadania-finansowane-z-budzetu-panstwa"
                },
                {
                    icon: "mdi-circle-outline",
                    text: "Fundusze europejskie",
                    url: "/fundusze-europejskie"
                },
                /*                {
                    icon: "mdi-circle-outline",
                    text: "Covid-19 informacje",
                    url: "/covid-19-informacje",
                },
*/
                {
                    icon: "mdi-circle-outline",
                    text: "Kontakt",
                    url: "/kontakt"
                }
            ],

            isEnabled: true,
            SocialTooltipItems: [
                {
                    icon: "mdi-instagram",
                    title: "instagram",
                    url: "https://www.instagram.com/ans.walbrzych/"
                },
                {
                    icon: "mdi-facebook",
                    title: "facebook",
                    url: "https://www.instagram.com/ans.walbrzych/"
                },
                {
                    icon: "mdi-magnify",
                    title: "szukaj",
                    url: "Szukaj"
                },
                {
                    icon: "mdi-magnify",
                    title: "szukaj",
                    url: "Szukaj"
                }
            ],

            isEnabled: true,
            searchValue: "",
            validateText: "",
            defaulturl: "/"
        };
    },

    methods: {
        handleTabPress(e) {
            this.tabmenu = true;
            document.body.classList.add("user-is-tabbing");
        },

        toggleState(state) {
            this.accessibilityStates[state] = !this.accessibilityStates[state];
            this.applyState(state);
            //console.log("click toggleState(state)", state);
        },
        applyState(state) {
            console.log("click applyState", state);
            if (state === "inverted") {
                this.resetHighlightLinks();
                this.resetGrayscale();
                this.accessibilityStates[state]
                    ? document.body.classList.add("accessibility-contrast")
                    : document.body.classList.remove("accessibility-contrast");
            } else if (state === "greyscaled") {
                this.resetHighlightLinks();
                this.resetInvertContrast();
                this.accessibilityStates[state]
                    ? document.body.classList.add("accessibility-greyscale")
                    : document.body.classList.remove("accessibility-greyscale");
            } else if (state === "highlighted") {
                this.resetGrayscale();
                this.resetInvertContrast();
                this.hightlightLinks();
            } else if (state === "accessibileFontSize") {
                this.accessibilityStates[state]
                    ? document.body.classList.add("accessibility-font")
                    : document.body.classList.remove("accessibility-font");

                /*
? document.body.classList.add("accessibility-font")
          : document.body.classList.remove("accessibility-font");
  */
            }
        },
        resetInvertContrast() {
            this.accessibilityStates.inverted = false;
            document.body.classList.remove("accessibility-contrast");
        },
        resetGrayscale() {
            this.accessibilityStates.greyscaled = false;
            document.body.classList.remove("accessibility-greyscale");
        },
        resetHighlightLinks() {
            this.accessibilityStates.highlighted = false;
            this.hightlightLinks();
        },
        hightlightLinks() {
            for (let link of this.links) {
                if (!link.classList.contains("accessibility-menu-item")) {
                    this.accessibilityStates.highlighted
                        ? link.classList.add("accessibility-highlight-link")
                        : link.classList.remove("accessibility-highlight-link");
                }
            }
        },
        invertContrast(percent) {
            document.body.style.setProperty("filter", `invert(${percent})`);
        },

        openUrl(url) {
            window.location.href = url;
        },
        search: _.debounce(function() {
            if (this.searchValue.trim() == "") {
                this.validateText =
                    "Pole Wpisz tutaj wyszukiwane słowo nie może być puste!";
            } else {
                if (this.searchValue.length > 2) {
                    axios({
                        method: "get",
                        url: `/q=${this.searchValue}`
                    })
                        .then(response => {
                            const searchObj = {
                                isSearchLoader: false,
                                isSearchResult: true,
                                data: response.data
                            };

                            this.$store.commit("setSearchData", searchObj);
                            this.dialog = false;
                            this.validatetext = "";
                            //     console.log('search data', response.data)
                        })
                        .catch(error => {
                            //  console.log(error);
                        });
                } else {
                    this.validateText =
                        "Wyszukiwane słowo musi składać się z co najmniej 3 znaków!";
                }
            }
        }, 500)
    },

    mounted() {
        if (localStorage.getItem("accessibility-settings")) {
            this.accessibilityStates = JSON.parse(
                localStorage.getItem("accessibility-settings")
            );
            for (var state in this.accessibilityStates) {
                if (this.accessibilityStates[state]) this.applyState(state);
            }
        }
    },
    computed: {
        ...mapGetters(["setSearchData"]),
        height() {
            switch (this.$vuetify.breakpoint.name) {
                case "xs":
                    return 220;
                case "sm":
                    return 400;
                case "md":
                    return 500;
                case "lg":
                    return 600;
                case "xl":
                    return 800;
            }
        },
        links() {
            return [...document.querySelectorAll("a")];
        }
    }
};
</script>

<style>
.accessibility-font {
    font-size: 1.5rem;
}

.accessibility-greyscale {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    filter: grayscale(100%);
    min-height: 100vh;
}

.accessibility-contrast {
    -webkit-filter: invert(100%);
    -moz-filter: invert(100%);
    filter: invert(100%);
    min-height: 100vh;
}

.accessibility-highlight-link {
    padding: 3px;
    background-color: black !important;
    color: yellow !important;
    text-decoration: underline !important;
}
</style>

<style scoped>
.skip-to-content-link {
    background: #05355a;
    height: 30px;
    left: 50%;
    margin-bottom: 3px;
    padding: 5px;
    position: absolute;
    transform: translateY(-100%);
    transition: transform 0.3s;
}

.skip-to-content-link:focus {
    transform: translateY(50%);
}
.bg-red-line {
    background-image: url("/images/header-red-line.png");
    background-repeat: repeat-x;
}

.bg-blue-line {
    background-image: url("/images/header-blue-line.png");
    background-repeat: repeat-x;
}
ul {
    border: 0px solid red;
    margin: 0px;
    padding: 0px;
}
li:first-child {
    border-bottom: 0px solid #db0f38;
    background: #db0f38;
}

li {
    display: inline-flex;
    padding: 2px;
    margin: 2px;
    padding: 5px;
}

a,
a:link,
a:visited {
    text-decoration: none;
    color: white;
}

/* mouse over link */
a:hover.id {
    color: orangered;
}

/* selected link */
a:active.id {
    color: black;
}

/* Remove outline for non-keyboard :focus */

:focus {
    border: 2px solid orange;
}
body.user-is-tabbing *:focus {
    border: 2px solid orange;
}
</style>
